import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Estado compartido del módulo de marketing: el emisor seleccionado se mantiene
 * al navegar entre las pestañas (Dashboard, Contactos, Pipeline, etc.).
 */
interface MarketingState {
  emisorId: number | null;
  setEmisorId: (id: number | null) => void;
}

export const useMarketingStore = create<MarketingState>()(
  persist(
    (set) => ({
      emisorId: null,
      setEmisorId: (id) => set({ emisorId: id }),
    }),
    { name: "inpronexus.marketing.ctx" },
  ),
);
